import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import ThankYou from './pages/ThankYou';
import EventRegister from './pages/EventRegister';
import BookSlot from './pages/BookSlot';
import ApplicationForm from './pages/ApplicationForm';
import SignatureUpload from './pages/SignatureUpload';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/optin" element={<Home />} />
          <Route path="/thankyou" element={<ThankYou />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/event/:slug" element={<EventRegister />} />
          <Route path="/book/:slug" element={<BookSlot />} />
          <Route path="/apply/:slug" element={<ApplicationForm />} />
          <Route path="/signature/:slug" element={<SignatureUpload />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
